import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useMobile } from "@krea/customer-features/hooks";
import Button from "@krea/customer-features/shared-components/button";
import { Text } from "@krea/customer-features/shared-components/text";
import { useGetUserData } from "@krea/customer-features/store/user/hooks/queries/useGetUserData";
import { SimpleTooltip } from "@krea/shared/design-system/Tooltip";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

import { useGetCurrentLoanApplication } from "store/current-loan-application/hooks/queries";
import { useGetLoanApplications } from "store/loan-applications/hooks/queries";

import { MenuContext } from "../header/header-context";

export const ApplicationSelector = () => {
  const { t } = useTranslation();
  const isMobile = useMobile();

  const { data: user } = useGetUserData();
  const { data: activeLoanApplications } = useGetLoanApplications(!!user?.id);
  const { data: loanApplication } = useGetCurrentLoanApplication();
  const { applyingCompany } = loanApplication ?? {};

  const buttonText = t("applicationSummary.change");
  const activeLoanApplicationsCount = activeLoanApplications?.length ?? 0;
  const companyName = applyingCompany?.customerCompany.name;
  const { toggleMenu, openApplicationSelector } = useContext(MenuContext);

  return (
    <>
      {!isMobile ? (
        <div className="tw-ml-4 tw-flex">
          {companyName && (
            <div
              className={twMerge("tw-flex tw-items-center", {
                "tw-pr-3": activeLoanApplicationsCount > 1,
              })}
              style={{ maxWidth: "10rem" }}
            >
              <SimpleTooltip
                trigger={
                  <Text
                    size="sm"
                    className="tw-w-full tw-truncate tw-font-bold tw-text-black"
                  >
                    {companyName}
                  </Text>
                }
              >
                {companyName}
              </SimpleTooltip>
            </div>
          )}

          {activeLoanApplicationsCount > 1 && (
            <Button
              variant="outlined"
              className="tw-shrink-0"
              onClick={() => {
                openApplicationSelector?.();
                if (toggleMenu) toggleMenu();
              }}
            >
              {buttonText}
            </Button>
          )}
        </div>
      ) : (
        <div className="tw-w-full md:tw-grow" style={{ minWidth: "0px" }}>
          <div className="tw-flex tw-flex-col tw-items-center tw-rounded tw-bg-gray tw-pb-4 md:tw-flex-row md:tw-p-0">
            <div
              className="tw-w-full tw-grow tw-pb-5 tw-text-center md:tw-pb-0 md:tw-pr-4 md:tw-text-left"
              style={{ minWidth: "0px" }}
            >
              {companyName && (
                <>
                  <Text size="sm" className="tw-font-bold tw-text-gray-700">
                    {t("applicationSummary.companyNameLabel")}
                  </Text>
                  <Text className="tw-truncate tw-font-bold">
                    {companyName}
                  </Text>
                </>
              )}
            </div>

            {activeLoanApplicationsCount > 1 && (
              <div className="tw-shrink-0">
                <Button
                  variant="text"
                  className="tw-px-4"
                  onClick={() => {
                    openApplicationSelector?.();
                    if (toggleMenu) toggleMenu();
                  }}
                >
                  {buttonText}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
